import React, { lazy } from 'react';

import { Route } from 'react-router-dom';

import TestPage from './test';

const DevelopmentLandingPage = lazy(() =>
  import(
    /* webpackChunkName: 'development-landing-page' */ 'modules/DevelopmentLandingPage'
  ),
);

const DjangoAdminLoginRedirect = lazy(() =>
  import(
    /* webpackChunkName: 'django-admin-login-redirect' */ './DjangoAdminLoginRedirect'
  ),
);

const DevRoutes = () => (
  <>
    <Route path="/development" element={<DevelopmentLandingPage />} />
    <Route
      path="/assets-alpha/storybook/index.html"
      onEnter={() => window.location.reload()}
    />
    <Route path="/test/*" element={<TestPage />} key="test page" />,
    <Route path="/localhost-login" element={<DjangoAdminLoginRedirect />} />
  </>
);

export default DevRoutes;
